import React from 'react';
import substancesImg from '../../images/iCARE-Substances.png';
import industryImg from '../../images/iCARE-Industry.png';
import riskFactorsImg from '../../images/iCARE-Risk-factors.png';
import communicationImg from '../../images/iCARE-Communication.png';

const Modules = () => {
  const modules = [
    {
      title: 'Neurobiology of Substance Use​',
      image: substancesImg,
    },
    {
      title: 'Industry Tactics & Media Literacy​',
      image: industryImg,
    },
    {
      title: 'Risk and Protective Factors​',
      image: riskFactorsImg,
    },
    {
      title: 'Effective Communication',
      image: communicationImg,
    },
  ];

  return (
    <section className="section">
      <div className="container">
        <div className="columns is-centered">
          <div className="column is-8">
            <div className="content is-medium">
              <h3 className="title is-4 has-text-centered mt-6 mb-4">
                iCARE has 4 Courses:
              </h3>
              <div className="columns is-multiline">
                {modules.map((module, index) => (
                  <div key={index} className="column is-half">
                    <div className="box has-text-centered">
                      <img src={module.image} alt={module.title} />
                      <h4 className="title is-5 has-text-primary">
                        {module.title}
                      </h4>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Modules;
